// @flow
import { uuidv4 } from "../../helpers"
import { DEFAULT_CHORD, toJSON as chordToJSON } from "../chord"
import { toJSON as effectToJSON } from "../effects"
import type { Chord, JSON as ChordJSON } from "../chord"
import type { Effect, JSON as EffectJSON } from "../effects"

export const COLOR = "#FABEBE"
const POLYSYNTH_TEXT = "PS"
const RADIUS = 45
const DEFAULT_WAVEFORM = "sine"
const DEFAULT_EFFECTS = []

export type Waveform = "sine" | "square" | "sawtooth" | "triangle"

export type PolySynthParams = {|
  id: string,
  chord: Chord,
  waveform: Waveform,
  effects: Effect[]
|}

export type PolySynth = {|
  +type: "polySynth",
  +id: string,
  +color: string,
  +text: string,
  +radius: number,
  data: {
    chord: Chord,
    waveform: Waveform,
    effects: Effect[]
  }
|}

export type JSON = $ReadOnly<{|
  type: "polySynth",
  id: string,
  data: {|
    chord: ChordJSON,
    waveform: Waveform,
    effects: EffectJSON[]
  |}
|}>

export const createPolySynth = (
  { id, chord, waveform, effects }: PolySynthParams = {
    id: uuidv4(),
    chord: DEFAULT_CHORD,
    waveform: DEFAULT_WAVEFORM,
    effects: DEFAULT_EFFECTS
  }
) => ({
  type: "polySynth",
  id,
  color: COLOR,
  text: POLYSYNTH_TEXT,
  radius: RADIUS,
  data: {
    chord,
    waveform,
    effects
  }
})

export const toJSON: PolySynth => JSON = polySynth => {
  const {
    type,
    id,
    data: { chord, waveform, effects }
  } = polySynth

  return {
    type,
    id,
    data: {
      chord: chordToJSON(chord),
      waveform,
      effects: effects.map(effectToJSON)
    }
  }
}
